import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface RecipeCardEntityParams {
  position: number;
  id: number;
}
export class RecipeCardEntity extends BaseEntityClass {
  id: number;
  position: number;

  constructor(params: RecipeCardEntityParams) {
    super();
    this.type = "recipe_card";
    this.entity_version = 2;
    this.id = params.id;
    this.position = params.position;
  }
}
